import { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'

export type NonprofitPartnerTagAssignment = {
  tag: { id: string; name: string; image: string | null }
  entityIds: string[]
}

export const buildBadgeFromTagMatch = (tagMatch: NonprofitPartnerTagAssignment | undefined) => {
  if (!tagMatch) return {}

  return { badge: { text: tagMatch.tag.name, ...(tagMatch.tag.image ? { image: tagMatch.tag.image } : {}) } }
}

export const getNonprofitPartnerTagAssignments: QueryFn<[string], NonprofitPartnerTagAssignment[]> = async (
  client,
  [_cacheKey]
) => {
  const { data } = await client.get<{ data: NonprofitPartnerTagAssignment[] }>('v1/content-tags/assignments', {
    withCredentials: true,
    params: { type: 'nonprofit_partner_tag' }
  })

  return data.data
}
